module.exports = __webpack_public_path__ + "img/tunisia-logo-icon.78a2dc9c.png";